import whitelabelColor from "./whitelabelColor";
import { WHITELABEL_DEFAULT_STYLE, WHITELABEL_FONTS } from "./whitelabelDefaults";

const PROVIDER_BODY_CLASSES = [
    "login-vivo",
    "login-vero",
    "login-unifique",
    "login-abc",
    "login-master",
    "login-wifeed",
];

export const WHITELABEL_BODY_CLASS = "login-whitelabel";

const CSS_VARIABLES = [
    "--wl-primary",
    "--wl-accent",
    "--wl-font",
    "--wl-background",
    "--wl-soft",
    "--wl-foreground",
    "--wl-primary-hover",
];

const SOFT_LIGHTEN_AMOUNT = 0.75;

function sanitizeColor(color, fallback) {
    return whitelabelColor.isHex(color) ? color : fallback;
}

function sanitizeFont(font) {
    return WHITELABEL_FONTS.includes(font) ? font : WHITELABEL_DEFAULT_STYLE.font;
}

function sanitizeBackground(background) {
    if (!background) return null;

    if (whitelabelColor.isHex(background)) return background;

    const { start, end } = whitelabelColor.parseGradient(background);

    if (!start) return null;

    return whitelabelColor.buildGradient(start, end);
}

export function sanitizeWhitelabelStyle(style = {}) {
    const charts = WHITELABEL_DEFAULT_STYLE.charts.map((defaultColor, index) =>
        sanitizeColor(style.charts && style.charts[index], defaultColor)
    );

    return {
        primary: sanitizeColor(style.primary, WHITELABEL_DEFAULT_STYLE.primary),
        accent: sanitizeColor(style.accent, WHITELABEL_DEFAULT_STYLE.accent),
        font: sanitizeFont(style.font),
        background: sanitizeBackground(style.background),
        charts,
    };
}

export function applyWhitelabelStyle(style) {
    const root = document.documentElement;

    root.style.setProperty("--wl-primary", style.primary);
    root.style.setProperty("--wl-accent", style.accent);
    root.style.setProperty("--wl-font", style.font);
    root.style.setProperty(
        "--wl-soft",
        whitelabelColor.lighten(style.primary, SOFT_LIGHTEN_AMOUNT)
    );
    root.style.setProperty(
        "--wl-foreground",
        whitelabelColor.foregroundFor(style.primary)
    );
    root.style.setProperty(
        "--wl-primary-hover",
        whitelabelColor.deriveHover(style.primary)
    );

    if (style.background) root.style.setProperty("--wl-background", style.background);

    PROVIDER_BODY_CLASSES.forEach((className) =>
        document.body.classList.remove(className)
    );

    document.body.classList.add(WHITELABEL_BODY_CLASS);
}

export function clearWhitelabelStyle() {
    const root = document.documentElement;

    CSS_VARIABLES.forEach((name) => root.style.removeProperty(name));

    document.body.classList.remove(WHITELABEL_BODY_CLASS);
}
